// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  stripe_token: 'STRIPE_TOKEN',
  paypal_token: 'PAYPAL_TOKEN',

  API_SECURITY: 'https://backend.ventadetiempoaire.mx',

  API_ACOMETIDA: 'https://acometida.ventadetiempoaire.mx',
  SOCKET_NAMESPACE: '/monitoreo',
  monitoreoSocketUseDevProxy: false,
  socketIoPath: '/socket.io',
  monitoreoSocketDisableUpgrade: true
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
